(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nac-video-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nac-video-slider')) return;

    const MAX_LIVE = 6; // most videos allowed to hold a decoder at once

    class NacVideoSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.speed = Number(this.dataset.speed) || 50;
        this.auto = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pos = this.track.scrollLeft;
        this.hold = false;
        this.inView = false;
        this.returning = false;
        this.visible = new Set();
        this.live = [];
        this.tick = this.tick.bind(this);

        // Videos: only those visible inside the row get a file and play
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) { this.visible.add(e.target); this.activate(e.target); }
            else { this.visible.delete(e.target); e.target.pause(); }
          });
        }, { root: this.track, threshold: 0.15 });
        this.querySelectorAll('video').forEach((v) => this.videoObserver.observe(v));

        // Section: pause everything when it is scrolled off the page
        this.sectionObserver = new IntersectionObserver(([e]) => {
          this.inView = e.isIntersecting;
          if (this.inView) { this.visible.forEach((v) => this.activate(v)); this.start(); }
          else { this.live.forEach((v) => v.pause()); this.stop(); }
        }, { threshold: 0.05 });
        this.sectionObserver.observe(this);

        // Arrows
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.nudge(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.nudge(1));

        // Pause drift while the shopper interacts
        this.track.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hold = true; });
        this.track.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && !this.dragging) this.resumeSoon(0); });
        this.track.addEventListener('touchstart', () => { this.hold = true; clearTimeout(this.resumeTimer); }, { passive: true });
        this.track.addEventListener('touchend', () => this.resumeSoon(3000), { passive: true });
        this.track.addEventListener('wheel', () => { if (!this.track.matches(':hover')) this.resumeSoon(3000); }, { passive: true });

        // Mouse drag on desktop
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.dragging = true; this.hold = true;
          this.dragX = e.clientX; this.dragLeft = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(e.pointerId);
        });
        this.track.addEventListener('pointermove', (e) => {
          if (this.dragging) this.track.scrollLeft = this.dragLeft - (e.clientX - this.dragX);
        });
        const endDrag = () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.track.classList.remove('is-dragging');
          if (!this.track.matches(':hover')) this.resumeSoon(3000);
        };
        this.track.addEventListener('pointerup', endDrag);
        this.track.addEventListener('pointercancel', endDrag);

        document.addEventListener('visibilitychange', this.onVisibility = () => {
          if (document.hidden) this.live.forEach((v) => v.pause());
          else if (this.inView) this.visible.forEach((v) => this.activate(v));
        });

        // Theme editor: jump to the selected video
        this.addEventListener('shopify:block:select', (e) => {
          this.hold = true;
          this.track.scrollTo({ left: e.target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
        this.addEventListener('shopify:block:deselect', () => this.resumeSoon(1000));
      }

      disconnectedCallback() {
        this.stop();
        clearTimeout(this.resumeTimer);
        this.videoObserver?.disconnect();
        this.sectionObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      activate(video) {
        if (!this.inView || document.hidden) return;
        if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
        this.live = this.live.filter((v) => v !== video);
        this.live.push(video);
        // Over budget: free the oldest videos that are no longer visible
        for (let i = 0; this.live.length > MAX_LIVE && i < this.live.length; ) {
          const v = this.live[i];
          if (!this.visible.has(v)) { this.release(v); this.live.splice(i, 1); } else i++;
        }
        const p = video.play();
        if (p) p.catch(() => {});
      }

      release(video) {
        video.pause();
        video.removeAttribute('src');
        video.load(); // frees the decoder, especially on iPhone
      }

      resumeSoon(ms) {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => { this.hold = false; this.pos = this.track.scrollLeft; }, ms);
      }

      nudge(dir) {
        this.hold = true;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = (this.cards[0]?.offsetWidth || 0) + gap;
        this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
        this.resumeSoon(3000);
      }

      start() {
        if (!this.auto || this.frame) return;
        this.last = null;
        this.frame = requestAnimationFrame(this.tick);
      }

      stop() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      tick(time) {
        this.frame = requestAnimationFrame(this.tick);
        const dt = this.last == null ? 0 : Math.min(time - this.last, 50) / 1000;
        this.last = time;
        if (this.hold || this.returning || document.hidden) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 0) return;
        // Shopper moved the row? Continue from where they left it
        if (Math.abs(this.track.scrollLeft - this.pos) > 3) this.pos = this.track.scrollLeft;
        this.pos += this.speed * dt;
        if (this.pos >= max) {
          this.pos = max;
          this.track.scrollLeft = max;
          // Reached the end: short pause, glide back to the start, carry on
          this.returning = true;
          setTimeout(() => {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(() => { this.pos = this.track.scrollLeft; this.returning = false; }, 1500);
          }, 1200);
          return;
        }
        this.track.scrollLeft = this.pos;
      }
    }

    customElements.define('nac-video-slider', NacVideoSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
